import { cloudRead } from './cloudStorage';
import { useSession, PROGRESS_KEY, SETTINGS_KEY } from '../store/session';
import { historyKey, mergeYearFromCloud } from '../lib/streak';

/**
 * Подтягивает состояние из CloudStorage при старте.
 *
 * Облако — зеркало, а не источник правды, поэтому конфликты решаются
 * в пользу большего: история наборов объединяется побитово, прогресс
 * берётся только если в нём больше повторений. Устройство, которое
 * лежало выключенным неделю, не должно откатывать чужой прогресс.
 */
export async function syncFromCloud(): Promise<void> {
  const year = new Date().getFullYear();
  const keys = [PROGRESS_KEY, SETTINGS_KEY, historyKey(year), historyKey(year - 1)];

  const data = await cloudRead(keys);
  if (!Object.keys(data).length) return;

  for (const y of [year, year - 1]) {
    const remote = data[historyKey(y)];
    if (remote) mergeYearFromCloud(y, remote);
  }

  const parse = <T,>(raw: string | undefined): Partial<T> => {
    if (!raw) return {};
    try {
      return JSON.parse(raw) as Partial<T>;
    } catch {
      return {};
    }
  };

  useSession
    .getState()
    .hydrate(parse(data[PROGRESS_KEY]), parse(data[SETTINGS_KEY]));
}
